<template>
  <el-tag v-if="processType != null" size="medium" :type="cssClass">
    <i v-if="!!icon" :class="[icon]"></i>
    {{ processTypeLabel }}
  </el-tag>
</template>

<script>
  import constants from "../../constants";

  export default {
    name: "doc-process-type-tag",
    props: ["processType"],

    data() {
      return {
        icon: null,
        processTypeLabel: null,
        cssClass: null,
      };
    },

    watch: {
      processType() {
        this.initComponent();
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      initComponent() {
        this.icon = this.getProcessTypeIcon();
        this.processTypeLabel = this.getProcessTypeLabel();
        this.cssClass = this.getCssClass();
      },

      getCssClass() {
        let processType = this.processType ? parseInt(this.processType) : null;
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "success";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "warning";
          case constants.PROCESS_TYPE.NHANDEBIET:
          default:
            return "";
        }
      },

      getProcessTypeIcon() {
        let processType = this.processType ? parseInt(this.processType) : null;
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "fas fa-user";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "fas fa-users";
          case constants.PROCESS_TYPE.NHANDEBIET:
            return "fas fa-info";
          default:
            return "";
        }
      },

      getProcessTypeLabel() {
        let processType = this.processType ? parseInt(this.processType) : null;
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "Chủ trì";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "Phối hợp";
          case constants.PROCESS_TYPE.NHANDEBIET:
            return "Nhận để biết";
          default:
            return "";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-process-type-tag.vue